import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'deposit-paydox.component',
  templateUrl: '../sharedTemplates/deposit-paydox.component.html',
})
export class DepositPaydoxComponent implements OnInit {
  creditcardDatas: UntypedFormGroup;
  creditcardDataRaw: any;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private route: ActivatedRoute
  ) {
    //  Validators.pattern(/^-?(0|[1-9]\d*)?$/)
    this.creditcardDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(50000)]),
    });
  }

  ngOnInit() {
    this.creditcardDatas.statusChanges.subscribe(statusChanges => {
      // ////console.log("statusChanges", statusChanges);
    });

    this.creditcardDatas.valueChanges.subscribe(x => {
      // ////console.log("X", x);
      this.creditcardDataRaw = x;
    });

    this.route.queryParams.subscribe(params => {
      //orderid/:ordercode/:goapihash
      const orderid = params['orderid'];
      const ordercode = params['ordercode'];
      const goapihash = params['goapihash'];
      ////console.log("orderid", orderid);
      this.checkPaymentResult(orderid, ordercode, goapihash);
    });
  }

  submitCreditCardData() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositPaydox(this.creditcardDataRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      const resultStatu = result.split('|')[0];
      const resultValue = result.split('|')[1];
      if (resultStatu == '') {
        this._UiHelper.errorSnackBar('System Error', '');
      } else {
        if (resultStatu == 'error') {
          //let t_message = translator.transform(resultValue, null);

          this._UiHelper.errorSnackBar(resultValue, '');
        } else if (resultStatu == 'success') {
          //let t_message = translator.transform(result.message, null);

          //this._UiHelper.errorSnackBar(t_message, '');
          window.open(resultValue, '_self');
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }

  checkPaymentResult(orderid, ordercode, goapihash) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositPaydoxReturn(orderid, ordercode, goapihash).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      const resultStatu = result.split('|')[0];
      const resultValue = result.split('|')[1];
      if (resultStatu == '') {
        this._UiHelper.errorSnackBar('System Error', '');
      } else {
        if (resultStatu == 'error') {
          const t_message = translator.transform(resultValue, null);
          this._UiHelper.errorSnackBar(resultValue, '');
        } else if (resultStatu == 'success') {
          const t_message = translator.transform(resultValue, null);
          this._UiHelper.successSnackBar(t_message, '');
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
